import { DYNAMIC_DATA_TTL_MS } from './raiderApi'

const MAX_PAGE_CACHE_ENTRIES = 24
const pageDataCache = new Map()

function trimPageDataCache() {
  if (pageDataCache.size <= MAX_PAGE_CACHE_ENTRIES) return

  const entries = [...pageDataCache.entries()]
    .sort(([, left], [, right]) => left.lastAccessedAt - right.lastAccessedAt)

  while (pageDataCache.size > MAX_PAGE_CACHE_ENTRIES && entries.length) {
    const [key] = entries.shift()
    pageDataCache.delete(key)
  }
}

export function createPageCacheKey(page, filters = {}) {
  const params = Object.entries(filters)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value ?? ''))}`)
    .join('&')

  return `${page}?${params}`
}

export function getPageDataCache(key, ttl = DYNAMIC_DATA_TTL_MS) {
  const entry = pageDataCache.get(key)
  if (!entry) return null

  entry.lastAccessedAt = Date.now()
  return {
    data: entry.data,
    updatedAt: entry.updatedAt,
    isFresh: Date.now() - entry.updatedAt < ttl,
  }
}

export function setPageDataCache(key, data, options = {}) {
  const now = Date.now()
  pageDataCache.set(key, {
    data,
    updatedAt: Number(options.updatedAt || now),
    lastAccessedAt: now,
  })
  trimPageDataCache()
}

export function deletePageDataCache(key) {
  pageDataCache.delete(key)
}
